import React from "react"
import ReactDOM from "react-dom"
import styled from "styled-components"
import { motion } from "framer-motion"

const Layer = styled(motion.div)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 12;
  padding: 10vh 15px 15px;
  overflow-y: auto;
`

const InnerLayer = styled(motion.div)`
  margin: 0 auto;
  max-width: 600px;
  width: 100%;
  transform: translateY(0);
`

const variants = {
  open: { opacity: 1, display: "block" },
  closed: { opacity: 0, transitionEnd: { display: "none" } },
}

const innerVariants = {
  open: { opacity: 1, y: 0, display: "block" },
  closed: { opacity: 0, y: "40px", transitionEnd: { display: "none" } },
}

const Modal = ({ children, show, setShow, onVisibilityChange }) => {
  const layerRef = React.useRef(null)

  const closeOnOutsideClick = React.useCallback(
    (e, ref) => {
      if (e.target === ref.current) {
        setShow(false)
      }
    },
    [setShow]
  )

  React.useEffect(() => {
    if (onVisibilityChange) {
      onVisibilityChange(show)
    }
  }, [show, onVisibilityChange])

  React.useEffect(() => {
    const handleEsc = event => {
      if (event.keyCode === 27) {
        setShow(false)
      }
    }

    window.addEventListener("keydown", handleEsc)

    return () => {
      window.removeEventListener("keydown", handleEsc)
    }
  }, [setShow])

  if (typeof window === "undefined") {
    return null
  }

  const portal = document.getElementById("modalContainer")

  if (!portal) {
    return null
  }

  return ReactDOM.createPortal(
    <Layer
      animate={show ? "open" : "closed"}
      variants={variants}
      transition={{ duration: 0.4 }}
      initial={false}
      ref={layerRef}
      onClick={e => closeOnOutsideClick(e, layerRef)}
    >
      <InnerLayer
        animate={show ? "open" : "closed"}
        variants={innerVariants}
        transition={{ duration: 0.6 }}
        initial={false}
      >
        {children}
      </InnerLayer>
    </Layer>,
    portal
  )
}

export { Modal }
